import {styleAndCapture} from 'external/material'
import { homeworkColor, assessmentColor } from 'settings'

import useTranslations from 'hooks/translations'
import useCatalog from 'hooks/catalog'

import { centerVertically } from 'utils/style'

const StyledDashboardActivityItemType = styleAndCapture('div', 'backgroundColor', 'textColor')(dashboardActivityItemTypeStyles)

export default function DashboardActivityItemType(props) {

    const {translate} = useTranslations()
    const {type, course, content} = props
    const {subjects = {}} = useCatalog()
      const {color: bgcolor, textColor} = content.subject
        ? subjects[course.substring(0,2)] || {}
        : {}
    const backgroundColor = type == 'assignment'
        ? assessmentColor
        : type == 'homework'
            ? homeworkColor
            : bgcolor

    return(<StyledDashboardActivityItemType textColor={textColor} backgroundColor={backgroundColor}>
        {translate(`${type}-activity-label`)}
        </StyledDashboardActivityItemType>
   )
}
function dashboardActivityItemTypeStyles({textColor, backgroundColor}){
    return {
        flexShrink: 0,
        flexGrow: 0,
        width: 100,
        padding: '8px 12px',
        ...centerVertically,
        textAlign: 'center',
        fontSize: '10.5pt',
        borderRadius: 20,
        backgroundColor: backgroundColor || '#eb5ac6',
        color: textColor || '#fff'
    }
}